import sharePopup from './share-popup.js';
import { getShares, getTeaserCount } from './sharedcount.js';

const socialShares = () => {
	let checkForCountMe = document.getElementById('countme');

	if (checkForCountMe) {
		getShares();
	}

	getTeaserCount();

	//  Do the sharers (Refactored from jQuery)
	//  ===================================================

	//  Facebook
	let facebookShare = document.querySelectorAll(".social-share .facebook");

	for (let i = 0; i < facebookShare.length; i++) {
		facebookShare[i].addEventListener('click', function (i, event) {
			event.preventDefault(event);
			const u = document.querySelector('link[rel=canonical]').getAttribute('href');
			const t = document.title;
			sharePopup('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t));
			return false;
		}.bind(this, i));
	}

	//  Twitter
	let twitterShare = document.querySelectorAll(".social-share .twitter");
	for (let i = 0; i < twitterShare.length; i++) {
		twitterShare[i].addEventListener('click', function (i, event) {
			event.preventDefault(event);
			const u = document.querySelector('link[rel=canonical]').getAttribute('href');
			const t = document.title + '-';
			sharePopup('https://twitter.com/share?url=' + encodeURIComponent(u) + '&text=' + encodeURIComponent(t) + '&via=brightlocal');
			return false;
		}.bind(this, i));
	}

	//  Linkedin
	let linkedinShare = document.querySelectorAll(".social-share .linkedin");

	for (let i = 0; i < linkedinShare.length; i++) {
		linkedinShare[i].addEventListener('click', function (i, event) {
			event.preventDefault(event);
			const u = document.querySelector('link[rel=canonical]').getAttribute('href');
			const t = document.title;

			const checkSelector = document.querySelector("meta[name='description']");

			let doc = document.querySelector("meta[property='og:description']").getAttribute('content');

			if (checkSelector != null) {
				doc = document.querySelector("meta[name='description']").getAttribute('content');
			}

			sharePopup('https://www.linkedin.com/shareArticle?mini=true&url='
				+ encodeURIComponent(u)
				+ '&title='
				+ encodeURIComponent(t)
				+ '&summary='
				+ encodeURIComponent(doc)
				+ '&source='
				+ encodeURIComponent('https://www.brightlocal.com') + '');
			return false;
		}.bind(this, i));
	}

	//  Twitter quotes
	let twitterQuotes = document.querySelectorAll(".tweet-panel");

	for (let i = 0; i < twitterQuotes.length; i++) {
		twitterQuotes[i].addEventListener('click', function (i, event) {
			event.preventDefault(event);
			const u = document.querySelector('link[rel=canonical]').getAttribute('href');
			const t = twitterQuotes[i].querySelector('.tweettext').innerText;
			sharePopup('https://twitter.com/share?url=' + encodeURIComponent(u) + '&text=' + encodeURIComponent(t) + '');
			return false;
		}.bind(this, i));
	}
}

export default socialShares;